import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import TmpListComponent from "../../components/2.1/_tmp/TmpListComponent";
import TmpFormComponent from "../../components/2.1/_tmp/TmpFormComponent";


export const _TMPPage = (props) => {

  const {t} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();

  useEffect(() => {
    document.title = 'TMP' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('tmp')[0]) {
        document.getElementsByClassName('tmp')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerender_TMPPage]);

  return (
    <div className={"_TMPPage"}>

      {/* <SubstitutionFormComponent />
      <SubstitutionListComponent /> */}
      {/* <VatrateFormComponent />
      <VatrateListComponent /> */}


      {localStorage.getItem('module_inventory') ? (
        <>







          {entity === 'manufacturer' && (!action || action === 'update' || action === 'create') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    Tmpk listája
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <a onClick={() => {
                    history.push('/tmp/create')
                  }}
                     className={"p-button  p-button-success p-ml-2"}>
                    <i className={"pi pi-plus"}></i>
                    &nbsp;
                    Új tmp
                  </a>
                </div>
              </div>
              <Panel>
                <TmpListComponent backlink={'/tmp'}/>
              </Panel>
            </div>
          }
          {entity === 'manufacturer' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/tmp')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      Tmp {id ? (<>módosítása</>) : (<>létrehozása</>)}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/tmp')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      Vissza
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <TmpFormComponent backlink={'/tmp'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }










        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(_TMPPage);
